/**
 * @generated SignedSource<<a7e563cb0be5e5383070bf947908176c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_item$data = {
  readonly dealerDetailsDisplayInfo?: {
    readonly ctas: {
      readonly showMakeOffer: boolean | null;
    } | null;
  } | null;
  readonly seller: {
    readonly __typename?: "Seller";
    readonly isAccessible: boolean | null;
    readonly isRewardsTier2: boolean | null;
    readonly liveStorefrontProfile: {
      readonly aboutUsUnbranded: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsBio_seller" | "PdpSharedDealerDetailsHeader_seller" | "PdpSharedDealerDistinction_seller" | "PdpSharedDealerInfo_seller" | "PdpSharedSellerDetailsReviewContainer_seller">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_item" | "PdpSharedCallDealerCta_item" | "PdpSharedSellerTabsVariant_item" | "useRemoveNegotiationTest_item">;
  readonly " $fragmentType": "PdpRespDealerDetails_item";
};
export type PdpRespDealerDetails_item$key = {
  readonly " $data"?: PdpRespDealerDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_item",
  "selections": [
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedCallDealerCta_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContactDealerInlineForm_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerTabsVariant_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useRemoveNegotiationTest_item"
        },
        {
          "alias": "dealerDetailsDisplayInfo",
          "args": null,
          "concreteType": "ItemDisplayInfo",
          "kind": "LinkedField",
          "name": "displayInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CTADisplay",
              "kind": "LinkedField",
              "name": "ctas",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "showMakeOffer",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedSellerDetailsReviewContainer_seller"
            }
          ]
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerDetailsBio_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerDetailsHeader_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerDistinction_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerInfo_seller"
        },
        {
          "alias": "isRewardsTier2",
          "args": [
            {
              "kind": "Literal",
              "name": "listName",
              "value": "SELLER_REWARDS_2"
            }
          ],
          "kind": "ScalarField",
          "name": "isAnchorListMember",
          "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StorefrontProfile",
          "kind": "LinkedField",
          "name": "liveStorefrontProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "aboutUsUnbranded",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "8b30b66e575fc305a0b4782867671828";

export default node;
